import { Center, Text, CenterProps } from '@chakra-ui/react';

export default function None(props: CenterProps) {
  return (
    <Center opacity="0" py={4} {...props}>
      <Text>0</Text>
    </Center>
  );
}
